import { render, staticRenderFns } from "./PendencyEditModal.vue?vue&type=template&id=27a7aff9&scoped=true"
import script from "./PendencyEditModal.vue?vue&type=script&lang=js"
export * from "./PendencyEditModal.vue?vue&type=script&lang=js"
import style0 from "./PendencyEditModal.vue?vue&type=style&index=0&id=27a7aff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7aff9",
  null
  
)

export default component.exports